<template>
  <v-dialog
    v-model="opened"
    content-class="rate-dialog"
    max-width="370"
    persistent
  >
    <h3 class="rate-dialog__title">{{ title }}</h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-form
      ref="rate-dialog"
      :class="{ 'disabled-area': !$can('rent_rate_edit') }"
      @submit.prevent="item ? onUpdate() : onCreate()"
    >
      <v-text-field
        v-model="name"
        class="mb-3"
        dense
        outlined
        :label="$t('companiesList.tableHeaders.name')"
        :rules="[isRequired]"
      />

      <v-slider
        v-model="rate"
        class="rate-dialog__percent"
        min="1"
        max="100"
        thumb-label="always"
        thumb-size="24"
        append-icon="mdi-percent-outline"
        :label="$t('common.table.percent')"
        :rules="[isRequired]"
      />

      <v-text-field
        v-model="description"
        dense
        outlined
        :label="$t('common.table.description')"
      />

      <v-btn
        v-if="$can('rent_rate_edit')"
        type="submit"
        color="warning"
        elevation="0"
        block
        :loading="loading"
        >{{ $t('common.btns.save') }}</v-btn
      >
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: null,
  },
  data: () => ({
    loading: false,

    name: '',
    rate: '',
    description: '',
  }),
  watch: {
    opened(val) {
      if (!val) {
        setTimeout(() => this.$refs['rate-dialog'].reset(), 300);
        this.$emit('close');
      }

      if (val && this.item) {
        this.name = this.item.name;
        this.rate = this.item.rate;
        this.description = this.item.description;
      }
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    title() {
      if (!this.$can('rent_rate_edit') && this.item) return this.item.name;
      return this.item ? this.$t('rates.edit') : this.$t('rates.add');
    },
  },
  methods: {
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },
    async onCreate() {
      const isValid = this.$refs['rate-dialog'].validate();

      if (!isValid) return;

      this.loading = true;
      const result = await this.$store.dispatch('rates/addNew', {
        name: this.name,
        rate: this.rate,
        description: this.description,
      });
      this.loading = false;

      this.$emit('updated', result);
    },
    async onUpdate() {
      const isValid = this.$refs['rate-dialog'].validate();

      if (!isValid) return;

      this.loading = true;
      const params = {
        name: this.name,
        rate: this.rate,
        description: this.description,
      };

      const result = await this.$store.dispatch('rates/updateItem', {
        id: this.item.id,
        params,
      });
      this.loading = false;

      this.$emit('updated', result);
    },
  },
};
</script>

<style lang="scss">
.rate-dialog {
  padding: 10px;
  background-color: #fff;

  &__title {
    margin-bottom: 20px;
    text-align: center;
  }
}
</style>
